// SPLIT A LIST INTO SMALLER GROUPS
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function splitList(list: any[], groupSize: number) {
    const result = [];
    for (let i = 0; i < list.length; i += groupSize) {
        result.push(list.slice(i, i + groupSize));
    }
    return result;
}
